import Main from "./page/main";

function App() {
  return (
    <>
      <Main />
    </>
  );
}

export default App;
